import icon1 from "../../assets/Rectangle 272.png";
import icon2 from "../../assets/Rectangle 274.png";
import icon3 from "../../assets/asnaf.svg";

const Footer = () => {
  return (
    <div className=" koja-footer">
      <div
        className="black-strip2  d-flex justify-content-center align-items-md-center"
        style={{ marginRight: "75px" }}
      >
        <div className="footer-label d-none d-md-block">
          <strong> مارا در شبکه های اجتماعی دنبال کنید : </strong>
          <p className="mt-5">
            آدرس ما: <br />
            استان: اصفهان، شهرستان : نجف آباد، بخش : مرکزی، شهر: نجف آباد، محله:
            جامی، کوچه شهیدنصراله رحیمی [93]، خیابان 15 خرداد شمالی [10]، پلاک:
            166.001، طبقه: اول
          </p>
          <p className="mt-5">تماس با ما : </p>
          <p className="mb-0">info@koja-najafabad.ir</p>
          <p className="mb-0">09216300789</p>
          <p className="mb-0">09133334731</p>
        </div>
        <div className="d-md-none">
          <a
            href="https://logo.samandehi.ir/Verify.aspx?id=344218&p=xlaoaodsaodsuiwkrfthmcsi"
            target="_blank"
          >
            {" "}
            <img alt="" className="mb-3" width={110} src={icon1} />
          </a>
          <a
            href="https://trustseal.enamad.ir/?id=281416&amp;Code=P6eRBRoq8uppqEtll2Bq"
            target="_blank"
          >
            {" "}
            <img alt="" className="mb-3" width={110} src={icon2} />{" "}
          </a>
          <a
          href="https://iranianasnaf.ir/Forms/Public/CorporateIdentityInquiry/default.aspx?m=1&i=7553826&c=0468414320"
          target="_blank"
        >
          {" "}
          <img alt="" className="mb-3" width={110} src={icon3} />{" "}
        </a>
        </div>
      </div>
      <div className="footer-box d-none d-md-block">
        <div className="footer-icon-box">
          <div className="footer-icon-item ms-3">
            <a
              href="https://iranianasnaf.ir/Forms/Public/CorporateIdentityInquiry/default.aspx?m=1&i=7553826&c=0468414320"
              target="_blank"
            >
              {" "}
              <img alt="" className="mb-3" width={110} src={icon3} />{" "}
            </a>
          </div>
          <div className="footer-icon-item ms-3">
            <a
              href="https://trustseal.enamad.ir/?id=281416&amp;Code=P6eRBRoq8uppqEtll2Bq"
              target="_blank"
            >
              {" "}
              <img alt="" className="mb-3" width={110} src={icon2} />{" "}
            </a>
          </div>
          <div className="footer-icon-item ms-3">
            <a
              href="https://logo.samandehi.ir/Verify.aspx?id=344218&p=xlaoaodsaodsuiwkrfthmcsi"
              target="_blank"
            >
              {" "}
              <img alt="" className="mb-3" width={110} src={icon1} />
            </a>
          </div>
        </div>
        <p>درباره ما</p>
        <p>
          کجا سامانه یکپارچه کارشناسی املاک در شهرستان نجف آباد می باشد که با
          هدف ارائه خدمات کارشناسی <br />
          املاک برای همشریان نجف آبادی و در سال ۱۴۰۱ شروع به فعالیت نمود.
        </p>
        <strong className="mb-3 mt-3">
          تمامی حقوق مادی و معنوی این وب سایت متعلق به سامانه کجا نجف آباد می
          باشد و هرگونه کپی برداری پیگرد قانونی دارد.
        </strong>
      </div>
      <div className="footer-box-mobile d-md-none">
        <p className="mt-5 mb-3">ما را در شبکه های اجتماعی دنبال کنید:</p>
        <p className="mt-2 mb-3">
          آدرس ما: <br />
          استان: اصفهان، شهرستان : نجف آباد، بخش : مرکزی، شهر: نجف آباد، محله:
          جامی، کوچه شهیدنصراله رحیمی [93]، خیابان 15 خرداد شمالی [10] ، پلاک:
          166.001، طبقه: اول
        </p>

        <p className="mt-2">تماس با ما : </p>
        <p className="mb-0">info@koja-najafabad.ir</p>
        <p className="mb-0">09216300789</p>
        <p className="mb-0">09133334731</p>
        <p className="mt-2 mb-3">
          درباره ما
          <br />
          کجا سامانه یکپارچه کارشناسی املاک در شهرستان نجف آباد می باشد که با
          هدف ارائه خدمات کارشناسی املاک برای همشریان نجف آبادی و در سال ۱۴۰۱
          شروع به فعالیت نمود.
        </p>
      </div>
    </div>
  );
};

export default Footer;
